import { Countries } from "types/Models/countries";
import { getIsStateRequired } from "utils/stateRequired";
import { object, string } from "yup";

const stateWhen = (countries: Countries[]) =>
  string().when("country", {
    is: (country: string) => getIsStateRequired(countries, country),
    then: string().required("state is required"),
    otherwise: string().notRequired(),
  });

export const taxCalculateSchema = (countries: Countries[] = []) =>
  object({
    seller_address: object({
      country: string().required("Country is required"),
      city: string().required("city is required"),
      address1: string().required("Address is required"),
      state: stateWhen(countries),
      zipCode: string().required("ZipCode is required"),
      uuid: string().required("Seller Address UUID is required"),
    }),
    buyer_address: object({
      country: string().required("Country  is required"),
      city: string().required("city is required"),
      address1: string().required("Address is required"),
      state: stateWhen(countries),
      zipCode: string().required("ZipCode is required"),
      uuid: string().required("Buyer Address UUID is required"),
    }),
    product_detail: object({
      uuid: string().required("Product Code is required"),
      tax_code: string().required("TaxCode is required"),
    }),
  });
